import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import type { SelectOption } from "./types";

interface Props {
  modelValue?: Array<string | number>;
  options?: SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  showSearch?: boolean;
  loading?: boolean;
  maxTagCount?: number | "responsive";
  status?: "" | "error" | "warning";
  notFoundContent?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiSelect',
  props: {
    modelValue: { default: () => [] },
    options: { default: () => [] },
    placeholder: { default: "Chọn nhiều..." },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    maxTagCount: { default: "responsive" },
    status: { default: "" },
    notFoundContent: { default: "Không có dữ liệu" }
  },
  emits: ["update:modelValue", "change", "search", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const normalizedOptions = computed(() =>
  (props.options || []).map((opt) => ({
    label: opt.label,
    value: opt.value,
    disabled: opt.disabled,
  }))
);

const removeAccent = (str: string) =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const filterOption = (input: string, option: any) => {
  const label = String(option?.label ?? "");
  return removeAccent(label).includes(removeAccent(input));
};

const innerValue = computed({
  get: () => props.modelValue ?? [],
  set: (val: Array<string | number>) => {
    emit("update:modelValue", val);
  },
});

const onChange = (val: Array<string | number>, options: any) => {
  emit("update:modelValue", val);
  emit("change", val, options);
};

const onSearch = (val: string) => emit("search", val);
const onBlur = (e: FocusEvent) => emit("blur", e);

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    mode: "multiple",
    options: normalizedOptions.value,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    "show-search": _ctx.showSearch,
    "filter-option": filterOption,
    "max-tag-count": _ctx.maxTagCount,
    status: _ctx.status,
    loading: _ctx.loading,
    "not-found-content": _ctx.notFoundContent,
    class: "ant-multi-select",
    onChange: onChange,
    onSearch: onSearch,
    onBlur: onBlur
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["value", "options", "placeholder", "disabled", "size", "allow-clear", "show-search", "max-tag-count", "status", "loading", "not-found-content"]))
}
}

})